'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Factory to build enum to parse a string to an enum. Throw error if string is not an enum value
 */
const createEnumParser = (enumType) => ((value) => {
    const enumValues = Object.values(enumType);
    if (!enumValues.includes(value)) {
        throw new Error('Can\'t parse this value');
    }
    return value;
});

exports.createEnumParser = createEnumParser;
//# sourceMappingURL=parse-enum.js.map
